module.exports = __webpack_public_path__ + "img/logo_nav.266b250a.png";